import { PrimaryButton } from '@liveoptics/react-ui';
import { useRequest } from 'ahooks';
import React, { useCallback, useState } from 'react';
import { verifyDell } from '../../../../api/api';
import { Error, VerifyOwnerState } from '../../../../enums';
import TextButton from '../../../buttons/TextButton';
import SelectionOption from '../SelectionOption';
import Form from '../form/Form';

const DellForm = (props: {
  projectId: number;
  onOptionChange: (option: SelectionOption) => void;
  onCancel: () => void;
  onSuccess: (state: VerifyOwnerState, email?: string) => void;
}) => {
  const [error, setError] = useState('');

  const verifyDellRequest = useRequest(verifyDell, {
    manual: true,
    debounceWait: 500,
  });

  const handleSaveClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      setError('');
      e.preventDefault();
      verifyDellRequest
        .runAsync(props.projectId)
        .then(() => {
          props.onSuccess(VerifyOwnerState.VerifyDell);
        })
        .catch(() => {
          setError(Error.VerifyDell);
        });
    },
    [props, verifyDellRequest]
  );

  return (
    <Form
      selectionOption={SelectionOption.Dell}
      error={error}
      renderActions={() => (
        <>
          <TextButton onClick={props.onCancel}>Cancel</TextButton>
          <PrimaryButton
            disabled={verifyDellRequest.loading}
            loading={verifyDellRequest.loading}
            loadingText="Loading..."
            clickFn={handleSaveClick}
          >
            Save
          </PrimaryButton>
        </>
      )}
      onChange={props.onOptionChange}
    ></Form>
  );
};

export default DellForm;
